import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { faCalendarDays, faCircleExclamation, faEye, faFileExcel, faFilePdf, faMagnifyingGlass, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { ModalExtratoFinanceiroComponent } from 'src/app/shared/modals/modal-extrato-financeiro/modal-extrato-financeiro.component';
import { DataService } from 'src/app/shared/services/data.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { HealthService } from '../../../services/saude/health.service';
@Component({
    selector: 'app-extrato-financeiro',
    templateUrl: './extrato-financeiro.component.html',
    styleUrls: ['./extrato-financeiro.component.css'],
})
export class ExtratoFinanceiroComponent {    
    maxMonth:any = null;
    today = new Date();

    loading: boolean = false;
    loadingPdf: boolean = false;
    loadingCsv: boolean = false;
    
    loadingPaginacaoMedico: boolean = false;
    loadingPaginacaoMensalidade: boolean = false;

    //Icones    
    faCalendarDays = faCalendarDays;
    faCircleExclamation = faCircleExclamation;
    faEye = faEye;
    faPdf = faFilePdf;
    faExcel = faFileExcel;
    faMagnifyingGlass = faMagnifyingGlass;
    faTriangleExclamation = faTriangleExclamation;
    extratoFinanceiro!: { cpf: any, doctorGuides: [], monthlyFee: [], number: 0, total: 0 };
    mes: string = 'Janeiro';
    //Variaveis
    beneficiary: any;
    beneficiaries: any[] = [];
    cpfResponsavel: any;
    dataLimiteInicial: any;
    dataLimiteFinal: any;
    dataInicial: any;
    dataFinal: any;
    dataAtual: any;
    dataHoje: any;
    medicoHospitalar: any;
    mensalidades: any;
    visibleIndexes: number[] = [];

    //Formulários
    formGroup: FormGroup = new FormGroup({
        categoryId: new FormControl(null),
        initialDate: new FormControl(null),
        finalDate: new FormControl(null),
        period: new FormControl(30),
        personCpf: new FormControl(null),
        itemsPerPage: new FormControl(5),
        isPaginated: new FormControl(true),
        page: new FormControl(0),
    });

    filtroMensalidades: any = { page: 1, itemsPerPage: 5, isPaginated: true, personCpf: null, initialDate: null, finalDate: null, period: null };
    filtroMedico: any = { page: 1, itemsPerPage: 5, isPaginated: true, personCpf: null, initialDate: null, finalDate: null, period: null };

    constructor(private bsLocaleService: BsLocaleService, private userService: UsuarioService, private healthService: HealthService,
        private data: DataService, private toast: ToastrService, private modalService: NgbModal) {

        this.maxMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0);

        //Alterando a data do calendário para pt-br
        this.bsLocaleService.use('pt-br');
        //Buscando dados do beneficiário
        this.userService.getBeneficiaries().subscribe(
            (res: any) => {
                this.beneficiaries = res;
                this.cpfResponsavel = this.beneficiaries[0].id;
                this.formGroup.get('personCpf')?.setValue(this.beneficiaries[0].id);
                this.data.filter = this.formGroup.value;
            }
        );
    }

    consultar() {
        if (this.loading == true) return;
        this.loading = true;
        this.healthService.getStatementComplete(this.formGroup.value).subscribe((res: any) => {
            let retorno = res.filter((x: any) => x.cpf == this.formGroup.get('personCpf')?.value)[0];
            this.extratoFinanceiro = retorno;
            this.medicoHospitalar = retorno.doctorGuides;
            this.mensalidades = retorno.monthlyFee;
            setTimeout(() => { this.loading = false; }, 1000);
        });
    }

    periodoSelecionado() {
        this.formGroup.get('initialDate')?.reset();
        this.formGroup.get('finalDate')?.reset();
    }

    periodoSelecionadoData() {
        this.formGroup.get('period')?.reset();
    }

    visualizarGuiaMedica(details: any) {
        const modalRef = this.modalService.open(ModalExtratoFinanceiroComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.details = details;
    }

    printPdf() {
        this.loadingPdf = true;
        this.healthService.getStatementPdf(this.formGroup.value).subscribe({
            next: (data: Blob) => {
                const a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                a.download = "Extrato Financeiro.pdf";
                a.href = URL.createObjectURL(data);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
                this.loadingPdf = false;
            },
            error: (err: any) => {
                this.loadingPdf = false;
                this.toast.error('Ocorreu algum erro, tente novamente mais tarde!');
            }
        }
        );
    }
    
    printCsv() {
        this.loadingCsv = true;
        this.healthService.getStatementCsv(this.filtroMedico).subscribe({
            next: (data: Blob) => {
                const a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                a.download = "Extrato Financeiro.csv";
                a.href = URL.createObjectURL(data);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
                this.loadingCsv = false;
            },
            error: (err: any) => {
                this.loadingCsv = false;
                this.toast.error('Ocorreu algum erro, tente novamente mais tarde!');
            }
        });
    }
    
    onChangeQuantidadeItensMedicoHospitalar(itemsPerPage: number) {
        if (this.loading == true || this.filtroMedico.itemsPerPage == itemsPerPage) return;

        this.loadingPaginacaoMedico = true;

        this.filtroMedico = this.formGroup.value;
        this.filtroMedico.itemsPerPage = itemsPerPage;

        this.healthService.getStatementComplete(this.filtroMedico).subscribe((res: any) => {
            let retorno = res.filter((x: any) => x.cpf == this.formGroup.get('personCpf')?.value)[0];
            this.medicoHospitalar = retorno.doctorGuides;
            setTimeout(() => { 
                this.loadingPaginacaoMedico = false;
             }, 1000);
        });
    }

    onChangeQuantidadeItensMensalidades(itemsPerPage: number) {
        if (this.loading == true || this.filtroMensalidades.itemsPerPage >= itemsPerPage) return;

        this.loadingPaginacaoMensalidade = true;

        this.filtroMedico = this.formGroup.value;
        this.filtroMedico.itemsPerPage = itemsPerPage;

        // this.filtroMensalidades.itemsPerPage = itemsPerPage;
        this.healthService.getStatementComplete(this.filtroMedico).subscribe((res: any) => {
            let retorno = res.filter((x: any) => x.cpf == this.formGroup.get('personCpf')?.value)[0];
            this.mensalidades = retorno.monthlyFee;
            setTimeout(() => { 
                this.loadingPaginacaoMensalidade = false;
             }, 1000);
        });
    }

    paginacaoMedicoHospitalar(page: number) {

        if (this.loading == true || this.filtroMedico.page == page ) return;

        this.loadingPaginacaoMedico = true;

        this.filtroMedico = this.formGroup.value;
        this.filtroMedico.page = page - 1;
        
        this.healthService.getStatementComplete(this.filtroMedico).subscribe((res: any) => {
            let retorno = res.filter((x: any) => x.cpf == this.formGroup.get('personCpf')?.value)[0];
            this.medicoHospitalar = retorno.doctorGuides;
            setTimeout(() => { this.loadingPaginacaoMedico = false; this.filtroMedico.page = page; }, 1000);
        });
    }

    paginacaoMensalidades(page: number) {

        if (this.loading == true || this.filtroMensalidades.page == page) return;

        this.loadingPaginacaoMensalidade = true;

        this.filtroMensalidades = this.formGroup.value;
        this.filtroMensalidades.page = page - 1;
                
        this.healthService.getStatementComplete(this.filtroMensalidades).subscribe((res: any) => {
            let retorno = res.filter((x: any) => x.cpf == this.formGroup.get('personCpf')?.value)[0];
            this.mensalidades = retorno.monthlyFee;
            setTimeout(() => { this.loadingPaginacaoMensalidade = false; this.filtroMensalidades.page = page; }, 1000);
        });
    }
}
